export function dropBackslashEscapes(html) {
    return html
        .replace(/\\\[/g, '[')
        .replace(/\\\]/g, ']')
        .replace(/\\\*/g, '*')
        .replace(/\\%/g, '%')
        .replace(/\\\$/g, '$')
        .replace(/\\-/g, '-')
        .replace(/\\:/g, ':')
        .replace(/\\\|/g, '|');
}
